<template>
  <div>
    <RemoveCardTemplates
      :showFooter="true"
      :modalName="removeCardTemplateModalName"
      v-show="isModalActive"
      @confirmAction="cofirmRemoveCardTemplate($event)"
      buttonLabel="Delete"
      colorVariation="secondary"
    >
      <template slot="header">
        Delete Template
      </template>
      <template slot="body">
        <span class="disclaimer inter"
          >You are about to delete ‘{{ cardIdToRemove.name }}’ from templates.
        </span>
      </template>
    </RemoveCardTemplates>

    <vue-good-table
      :columns="columns"
      :rows="templatesList"
      styleClass="vgt-table striped"
      @on-cell-click="onCellClick"
    >
      <div slot="emptystate">No card templates found!</div>
      <template slot="table-row" slot-scope="templatesList">
        <!-- CreatedAt column here -->
        <div v-if="templatesList.column.field === 'createdAt'">
          {{ defaultFormatAndParse(templatesList.row.createdAt) }}
        </div>

        <div
          class="email-holder"
          v-if="templatesList.column.field === 'createdByEmail'"
        >
          {{ templatesList.row.createdByEmail }}
        </div>

        <!-- Name column here -->
        <div v-else-if="templatesList.column.field === 'name'">
          <div v-if="cellIndexClicked[templatesList.row.originalIndex]">
            <form @submit.prevent>
              <div class="form-group">
                <textarea
                  rows="1"
                  placeholder="Template name..."
                  v-model="
                    cellIndexClicked[templatesList.row.originalIndex].editedName
                  "
                />
              </div>
            </form>
          </div>
          <span v-else class="minimal-text">{{ templatesList.row.name }}</span>
        </div>

        <!-- Message column here -->
        <div v-else-if="templatesList.column.field === 'message'">
          <div v-if="cellIndexClicked[templatesList.row.originalIndex]">
            <form @submit.prevent>
              <div class="form-group">
                <textarea
                  rows="6"
                  :maxlength="maxCharacters"
                  placeholder="Your thoughtful message..."
                  v-model="
                    cellIndexClicked[templatesList.row.originalIndex]
                      .editedMessage
                  "
                />
              </div>
            </form>
          </div>
          <span v-else class="minimal-text">{{
            templatesList.row.message
          }}</span>
        </div>

        <!-- Action column here -->
        <div v-else-if="templatesList.column.field === 'action'">
          <div v-if="!cellIndexClicked[templatesList.row.originalIndex]">
            <div
              class="edit-options "
              v-if="user.id === templatesList.row.createdById"
            >
              <span>Edit</span>

              <span @click.stop="showRemoveCardTemplateModal(templatesList.row)"
                >x</span
              >
            </div>
          </div>

          <div v-else>
            <div class="template-action">
              <span
                class="cancel"
                @click.stop="cancelEdition(templatesList.row)"
                >Cancel</span
              >

              <button class="button-gemnote button-gemnote--tiny">
                <span
                  @click.stop="editTemplate(templatesList.row.originalIndex)"
                  >Save</span
                >
              </button>
            </div>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DateFns from '@/mixins/DateFns'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'TemplatesList',
  mixins: [DateFns],
  props: {
    templatesList: {
      type: Array,
      required: true
    }
  },
  components: {
    VueGoodTable,
    RemoveCardTemplates: () => import('@/components/Universal/RemoveModal')
  },
  data() {
    return {
      removeCardTemplateModalName: 'removeModalCardTemplate',
      cellIndexClicked: new Array(this.templatesList.length),
      cardIdToRemove: -1,
      columns: [
        {
          label: 'Date Created',
          field: 'createdAt'
        },
        {
          label: 'Created by',
          field: 'createdByEmail'
        },
        {
          label: 'Template Name',
          field: 'name'
        },
        {
          label: 'Message',
          field: 'message'
        },
        {
          label: 'Edit',
          field: 'action',
          sortable: false,
          width: '100px'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      maxCharacters: state => state.order.maxCharacters
    }),
    ...mapGetters({
      activeModals: 'modal/activeModals'
    }),
    user() {
      return this.$store.getters['profile/user']
    },
    isModalActive() {
      return this.activeModals(this.removeCardTemplateModalName)
    }
  },
  methods: {
    onCellClick({ column, row }) {
      switch (column.field) {
        case 'action':
          if (
            !this.cellIndexClicked[row.originalIndex] &&
            this.user.id === row.createdById
          ) {
            let rowToEdit = {
              ...row,
              editedName: row.name,
              editedMessage: row.message
            }
            this.cellIndexClicked.splice(row.originalIndex, 1, rowToEdit)
          }
          break
      }
    },
    cancelEdition(row) {
      this.cellIndexClicked.splice(row.originalIndex, 1, null)
    },
    editTemplate(index) {
      this.$store.dispatch('cardTemplate/updateCardTemplate', {
        id: this.cellIndexClicked[index].id,
        name: this.cellIndexClicked[index].editedName,
        message: this.cellIndexClicked[index].editedMessage
      })
      this.cellIndexClicked.splice(index, 1, null)
    },

    showRemoveCardTemplateModal(card) {
      this.cardIdToRemove = card
      this.$store.dispatch(
        'modal/showRemoveModal',
        this.removeCardTemplateModalName
      )
    },
    cofirmRemoveCardTemplate() {
      this.$store.dispatch(
        'cardTemplate/removeCardTemplate',
        this.cardIdToRemove.id
      )
      this.cardIdToRemove = -1
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../global.scss';

h4 {
  margin-top: 0.5rem;
}

span.disclaimer {
  margin-top: 1rem;
  display: block;
}

.vgt-left-align {
  vertical-align: top !important;
}

.minimal-text {
  display: inline-block;
  width: 185px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edit-options {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span:first-child {
    text-decoration: underline;
    font-weight: bold;
    display: block;
    cursor: pointer;
    color: $darker-gray;
  }

  span:nth-child(2) {
    font-weight: 600;
    cursor: pointer;
  }
}

.form-group {
  margin-bottom: 0rem;
  textarea {
    padding: 0.5rem;
    border-radius: 0px;
    border-bottom: 0;
    background: inherit;
    border: 1px solid #979797;
    height: auto;
    resize: none;
    font-size: 0.875rem;
    font-family: $inter;

    &:focus {
      border-bottom: 0;
      border: 1px solid rgba(155, 155, 155, 0.317708);
      padding: 0.625rem;
    }
  }
}

.template-action {
  display: flex;
  justify-content: space-between;
  .cancel {
    /* align-self: center; */
    font-weight: bold;
    font-size: 0.5rem;
    cursor: pointer;
    border: 1px solid $onyx;
    height: 24px;
    display: flex;
    align-items: center;
    border-radius: 40px 0 0 40px;
    text-transform: uppercase;
    padding: 0 10px;
  }
  button {
    border-radius: 0 40px 40px 0;
    height: 24px;
    font-size: 0.5rem;
    padding: 0 14px !important;
    width: auto;
  }
}

.email-holder {
  width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
